import { render, staticRenderFns } from "./DistributeAccountR.vue?vue&type=template&id=60aca1df&scoped=true&"
import script from "./DistributeAccountR.vue?vue&type=script&lang=js&"
export * from "./DistributeAccountR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aca1df",
  null
  
)

export default component.exports